import styled from '@emotion/styled';
import type {
  FilterKindEnum,
  UpsellType,
  UserAttributeSingleFilterState,
} from '../../../domains/global-filters/model/FilterChain';
import { StyledMenuButton } from './StyledMenuButton';

const UnderlinedButton = styled(StyledMenuButton)`
  text-decoration: underline;
`;

function getLabel(filterState: UserAttributeSingleFilterState): string {
  const totalOfUserAttribute = filterState.config.userAttributeOptionList.length;
  if (filterState.config.isLocked === true || totalOfUserAttribute === 0) {
    return 'Add user attributes';
  }
  return `${totalOfUserAttribute} user attributes…`;
}

interface UserAttributeMenuButtonProps {
  filterState: UserAttributeSingleFilterState;
  onNewFilter: (kind: FilterKindEnum) => void;
  isMaxReached: boolean;
  onUpsellClicked?: (upsellType: UpsellType) => void;
}

export const UserAttributeMenuButton = ({
  filterState,
  onNewFilter,
  isMaxReached,
  onUpsellClicked,
}: UserAttributeMenuButtonProps): JSX.Element | null => {
  const isLoading = filterState.config.userAttributeOptionIsLoading;
  return (
    <UnderlinedButton
      key={filterState.kind}
      icon={filterState.config.isLocked === true ? 'lock' : 'chevron_right'}
      kind="ghost"
      size="s"
      onClick={() => {
        if (filterState.config.isLocked === true) {
          onUpsellClicked?.(filterState.kind);
        } else if (filterState.config.userAttributeOptionList.length === 0) {
          filterState.config.onAddMoreUserAttribute?.();
        } else {
          onNewFilter(filterState.kind);
        }
      }}
      isLocked={filterState.config.isLocked === true}
      isDisabled={isMaxReached}
      aria-label={`Add ${filterState.metaData.filterName}`}
      isLoading={isLoading}
    >
      {isLoading ? 'Loading...' : getLabel(filterState)}
    </UnderlinedButton>
  );
};
